
export const calculatePageRanges =
    (totalPages: number, startPage?: number, lastPage?: number, pageCount?: number) => {
        // No pages specified, show entire pdf
        if (typeof startPage === "undefined")
            return [1, totalPages];
        // From - To
        if (lastPage)
            return [startPage, Math.min(lastPage, totalPages)];
        // From - Do amount
        else if (pageCount)
            return [startPage, Math.min(startPage + pageCount, totalPages)];
        // One page is provided, show only that
        else
            return [startPage, startPage]
    }